import { createContext } from "react";
export var getEnvVars = function () {
    if (!(!!process.env.REACT_APP_TINYMCE_APIKEY &&
        !!process.env.REACT_APP_IMGS_FOLDER &&
        !!process.env.REACT_APP_RECAPTCHA_SITE_KEY &&
        !!process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET &&
        !!process.env.REACT_APP_CLOUDINARY_CLOUD_NAME)) {
        throw new Error("Some required env variables are missing!");
    }
    var tinyMCEAPIKey = process.env.REACT_APP_TINYMCE_APIKEY || "";
    var imgsFolder = process.env.REACT_APP_IMGS_FOLDER || "/imgs";
    var reCaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY
        ? process.env.REACT_APP_RECAPTCHA_SITE_KEY
        : "";
    var cloudinaryUploadPreset = process.env
        .REACT_APP_CLOUDINARY_UPLOAD_PRESET
        ? process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET
        : "";
    var cloudinaryCloudName = process.env
        .REACT_APP_CLOUDINARY_CLOUD_NAME
        ? process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
        : "";
    if (!(!!process.env.REACT_APP_API_URL &&
        !!process.env.REACT_APP_BN_API_URL &&
        !!process.env.REACT_APP_COMM_HUB_URL &&
        !!process.env.REACT_APP_USE_RECAPTCHA_ON_REGISTRATION &&
        !!process.env.REACT_APP_NAV_URL_KB &&
        !!process.env.REACT_APP_NAV_URL_RESC &&
        !!process.env.REACT_APP_SESSION_COOKIE_NAME &&
        !!process.env.REACT_APP_SESSION_COOKIE_DOMAIN &&
        !!process.env.REACT_APP_BN_TOKEN_REVALIDATION_THRESHOLD)) {
        console.warn("Some important env variables are missing!");
    }
    var gwApiURL = process.env.REACT_APP_API_URL || "";
    var bnApiURL = process.env.REACT_APP_BN_API_URL || "";
    var commHubURL = process.env.REACT_APP_COMM_HUB_URL || "";
    var bnTokenRevalidationThreshold = parseInt(process.env.REACT_APP_BN_TOKEN_REVALIDATION_THRESHOLD || "3600");
    var useReCaptcha = process.env.REACT_APP_USE_RECAPTCHA_ON_REGISTRATION === "true"
        ? true
        : false;
    var helpCenterNavUrl = process.env.REACT_APP_NAV_URL_KB ||
        "https://staging.hub.greenwave.gfolkdev.net/";
    var resourceNavUrl = process.env.REACT_APP_NAV_URL_RESC ||
        "https://staging.hub.greenwave.gfolkdev.net/category/4/resources";
    var ssCookieName = process.env.REACT_APP_SESSION_COOKIE_NAME || "gw-session-local";
    var ssCookieDomain = process.env.REACT_APP_SESSION_COOKIE_DOMAIN || "gwlocal.gfdev";
    var mapboxToken = process.env.REACT_APP_MAPBOX_TOKEN ||
        "pk.eyJ1IjoiZ3JlZW53YXZlIiwiYSI6ImNrczY5YnVkZTE0dXoydm9kODg5djlyZWYifQ.DeQaYuUEKlS92-CIhV30AA";
    var apiDebug = process.env.REACT_APP_API_DEBUG === "true" ? true : false;
    var showModelDebug = process.env.REACT_APP_SHOW_MODEL_DEBUG === "true" ? true : false;
    return {
        gwApiURL: gwApiURL,
        bnApiURL: bnApiURL,
        commHubURL: commHubURL,
        bnTokenRevalidationThreshold: bnTokenRevalidationThreshold,
        apiDebug: apiDebug,
        showModelDebug: showModelDebug,
        useReCaptcha: useReCaptcha,
        reCaptchaSiteKey: reCaptchaSiteKey,
        cloudinaryCloudName: cloudinaryCloudName,
        cloudinaryUploadPreset: cloudinaryUploadPreset,
        tinyMCEAPIKey: tinyMCEAPIKey,
        imgsFolder: imgsFolder,
        helpCenterNavUrl: helpCenterNavUrl,
        resourceNavUrl: resourceNavUrl,
        ssCookieDomain: ssCookieDomain,
        ssCookieName: ssCookieName,
        mapboxToken: mapboxToken,
    };
};
export var EnvContext = createContext({
    gwApiURL: "",
    tinyMCEAPIKey: "",
    imgsFolder: "",
    mapboxToken: "",
});
//# sourceMappingURL=EnvContext.js.map